import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import QuizSuccessMultiActionsCard from '../Quiz/QuizSuccessMultiActionsCard';
import PetitionSuccessMultiActionsCard from '../Petition/PetitionSuccessMultiActionsCard';
import EmailSuccessMultiActionsCard from '../Email/EmailSuccessMultiActionsCard';
import PollSuccessMultiActionsCard from '../Poll/PollSuccessMultiActionsCard';
import SentimentPollSuccessMultiActionsCard from '../SentimentPoll/SentimentPollSuccessMultiActionsCard';
import DonationSuccessMultiActionsCard from '../Donation/DonationSuccessMultiActionsCard';
import CallSuccessMultiActionsCard from '../Call/CallSuccessMultiActionsCard';
import VoteRegistrationSuccessMultiActionsCard from '../VoteRegistration/VoteRegistrationSuccessMultiActionsCard';
import ElectionReminderSuccessMultiActionsCard from '../ElectionReminder/ElectionReminderSuccessMultiActionsCard';
import CheckRegistrationSuccessMultiActionCard from '../CheckRegistration/CheckRegistrationSuccessMultiActionCard';
import FindPollingStationSuccessMultiActionCard from '../FindPollingStation/FindPollingStationSuccessMultiActionCard';
import VolunteerSuccessMultiActionCard from '../Volunteer/VolunteerSuccessMultiActionCard';

import CssTransition from '../../components/Transition/CssTransition';
import MultiActionsCardAction from '../../components/MultiActionsCard/MultiActionsCardAction';

import Carousel from '../../components/Shared/Carousel';

import ShareDrawer from '../../components/ShareDrawer';
import LocationChangePopup from '../../components/Volunteer/LocationChangePopup';

import { goToFindLocalRep, loadLocalRep, selectCard } from './actions';
import { copyFor } from '../../copy/copy';

import {
    onGoToNextActionInsideCard,
    setOverlayPartnerVisible,
    getApiRequestData
} from '../Widget/actions';

import { onCompleteTweet } from '../Tweet/actions';
import { onCompleteLink } from '../Link/actions';
import {
    fetchVolunteerOpportunities,
    onInitiateVolunteerAction,
    onShowLocationChangePopup
} from '../Volunteer/actions';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes, LocalRepState } from '../../utils/enums';
import { widthEm, isPortrait } from '../../utils/size';
import { Placeholders } from '../../utils/fillDynamicText';

import {
    relevantRepresentatives,
    joinEnglish
} from '../../utils/localRepresentative/parser';

import { Container, Body } from '../DefaultStyles/Details';
import { Footer } from '../DefaultStyles/Shared';

const Header = styled.h1`
    font-family: Averta;
    font-size: 28px;
    font-weight: 300;
    margin: 20px 0 10px;

    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }
`;

const Title = styled.h2`
    font-family: Averta;
    margin: 0 0 5px 0;
    font-weight: 300;
    font-size: 28px;
    word-wrap: break-word;
    width: 100%;
`;

const Description = styled.p`
    object-fit: contain;
    font-family: Lato;
    line-height: 1.33;
    color: #000;
    margin-bottom: 0.75em;
    word-break: break-word;
    font-size: ${() => (isPortrait() ? 16 : 15)}px;
    overflow: hidden;
    margin-top: 4px;

    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }
`;

const MultiActionsCardActionWrapper = styled.div`
    padding: 5px 20px 15px 20px;
    height: ${props =>
        props.isMultiDonation ? (isPortrait() ? 320 : 210) : isPortrait() ? 415 : 265}px;
    position: relative;
    margin: ${props => (props.numActions === 2 && !isPortrait() ? `0 6px` : ``)};
    flex: 1;
    border-right: 1px solid #f1f1ee;

    ${props =>
        (props.isMultiDonation && props.numActions > 2) ||
        (isPortrait() && props.isMultiDonation && props.numActions >= 2)
            ? `cursor: pointer`
            : ``};

    ${props =>
        (widthEm() < 30 || props.isMultiDonation) &&
        `
            display: flex;
            flex: 1;
            box-shadow: 0 2px 4px 0 #e4e4e4;
            border-radius: ${props.isMultiDonation ? `4px` : `0`};
            border: solid 1px #dadad9;
            padding: ${
                props.isMultiDonation && isPortrait()
                    ? `20px 15px 15px`
                    : `16px 11px 12px`
            };`};

    &:focus {
        outline: none;
    }

    &:last-child {
        ${props => (widthEm() > 30 || props.isMultiDonation ? `border-right: 0;` : ``)};
    }

    h2 {
        font-size: 24px;
        line-height: 110%;

        @media (max-width: 32em) {
            font-size: 20px;
        }

        @media (max-width: 30.0625em) {
            font-size: 24px;
        }
    }

    button {
        width: calc(100% - 40px);
        margin: 0;
        position: absolute;
        left: 20px;
        bottom: 0;
        word-break: break-word;
        span {
            font-size: ${() => (isPortrait() ? 24 : 18)}px;
        }

        &:active {
            background-color: #ff245e;
            border: solid 1px #ff245e;
            color: #fff;
            span {
                color: #fff;
            }
        }

        ${() =>
            !isPortrait() &&
            `
                &:hover {
                    background-color: #ff245e;
                    border: solid 1px #ff245e;
                    color: #fff;
                    span {
                        color: #fff;
                    }
                }`};

        ${props =>
            (widthEm() < 30 || props.isMultiDonation) &&
            `
                left: 10px;
                bottom: 12px;
                padding: 0;
                width: calc(100% - 20px);
            `};
    }
`;

const ActionContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    &.hide {
        display: none;
    }
`;

const ActionSuccess = styled.div`
    &.hide {
        display: none;
    }
`;

const PartnerImage = styled.img`
    width: auto !important;
    max-height: ${() => (widthEm() < 30 ? 45 : 35)}px;
`;

const actionButton = type => copyFor('multiactionCard', 'button', type);

const actionTitle = type => copyFor('multiactionCard', 'title', type);

const actionSuccess = (
    type,
    actionIdentifier,
    thankYouText,
    thankYouTitle,
    recipientMask,
    useLocalRepresentative,
    partnerName,
    pollResults,
    quizResults,
    name,
    feedbackText,
    quizAnsweredCorrect,
    quizMakeAnswersUppercase,
    localRepresentativeState,
    noOfPeopleAnswered
) => {
    switch (type) {
        case 'donation':
            return (
                <DonationSuccessMultiActionsCard
                    thankYouText={thankYouText}
                    partnerName={partnerName}
                />
            );
        case 'petition':
            return (
                <PetitionSuccessMultiActionsCard
                    thankYouText={thankYouText}
                    thankYouTitle={thankYouTitle}
                    useLocalRepresentative={useLocalRepresentative}
                />
            );
        case 'email':
            return (
                <EmailSuccessMultiActionsCard
                    thankYouText={thankYouText}
                    thankYouTitle={thankYouTitle}
                    recipientMask={recipientMask}
                    useLocalRepresentative={useLocalRepresentative}
                    localRepresentativeState={localRepresentativeState}
                />
            );
        case 'quiz':
            return (
                <QuizSuccessMultiActionsCard
                    feedbackText={feedbackText}
                    results={quizResults}
                    noOfAnswers={quizResults.length}
                    answeredCorrect={quizAnsweredCorrect}
                    makeUppercase={quizMakeAnswersUppercase}
                />
            );
        case 'poll':
            return (
                <PollSuccessMultiActionsCard
                    results={pollResults}
                    questionText={name}
                    noOfAnswers={pollResults.length}
                    noOfPeopleAnswered={noOfPeopleAnswered}
                />
            );
        case 'sentimentpoll':
            return (
                <SentimentPollSuccessMultiActionsCard
                    noOfPeopleAnswered={noOfPeopleAnswered}
                />
            );
        case 'call':
            return (
                <CallSuccessMultiActionsCard
                    thankYouText={thankYouText}
                    thankYouTitle={thankYouTitle}
                    recipientMask={recipientMask}
                    localRepresentativeState={localRepresentativeState}
                    useLocalRepresentative={useLocalRepresentative}
                />
            );
        case 'voteregistration':
            return <VoteRegistrationSuccessMultiActionsCard />;
        case 'electionreminder':
            return <ElectionReminderSuccessMultiActionsCard />;
        case 'checkregistration':
            return <CheckRegistrationSuccessMultiActionCard />;
        case 'findpollingstation':
            return <FindPollingStationSuccessMultiActionCard />;
        case 'volunteer':
            return <VolunteerSuccessMultiActionCard />;
        default:
            return;
    }
};

const actionDescription = (description, actionsLength, isMobileResolution) => {
    if (!description) return;
    const charLimit = isMobileResolution ? 190 : 135;
    return description.length > charLimit
        ? description.substring(0, charLimit) + '...'
        : description;
};

const actionCompleted = (action, completedActionIdentifiers) => {
    return completedActionIdentifiers.find(
        completed => completed.type === action.type && completed.id === action.identifier
    );
};

class MultiActionsCardDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: false
        };

        if (!props.localRepFound && props.useLocalRepresentative) props.loadLocalRep();
    }

    render() {
        const carouselSettings = {
            arrows: this.props.actions.length > 2,
            enableLabels: false,
            label: '',
            dots: false,
            infinite: false,
            speed: 500,
            swipeToSlide: true,
            centerMode: false,
            slidesToShow: isPortrait() ? 1 : this.props.actions.length > 2 ? 2.21 : 2,
            slidesToScroll: 1,
            focusOnSelect: true,
            draggabe: true
        };

        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner transitionType="right-to-left" />
                <Body>
                    <WidgetHeader />
                    {this.props.isMultiDonation && (
                        <Header
                            onClick={e =>
                                this.props.setOverlayPartnerVisible(true, e, false)
                            }
                            dangerouslySetInnerHTML={{
                                __html: this.props.mutiDonationHeader
                            }}
                        />
                    )}
                    <Carousel
                        carouselSettings={carouselSettings}
                        className={() => (isPortrait() ? 'carousel-mobile' : '')}
                        hover={this.state.hover}
                        isMultiDonation={this.props.isMultiDonation}
                        numActions={this.props.actions.length}
                        onMouseEnter={() => this.setState({ hover: true })}
                        onMouseLeave={() => this.setState({ hover: false })}
                        showSlider={
                            (isPortrait() || this.props.isMultiDonation) &&
                            this.props.actions.length > 1
                        }
                    >
                        {this.props.actions.map(a => (
                            <MultiActionsCardActionWrapper
                                numActions={this.props.actions.length}
                                isMultiDonation={this.props.isMultiDonation}
                                key={a.identifier}
                                selectCard={this.props.selectCard}
                            >
                                {a.type !== 'link' &&
                                    a.type !== 'tweet' &&
                                    actionCompleted(
                                        a,
                                        this.props.completedActionIdentifiers
                                    ) && (
                                        <ActionSuccess>
                                            {actionSuccess(
                                                a.type,
                                                a.identifier,
                                                a.thankYouText,
                                                a.thankYouTitle,
                                                a.recipientMask,
                                                a.useLocalRepresentative,
                                                a.partnerName,
                                                a.pollResults,
                                                a.quizResults,
                                                a.name,
                                                a.feedbackText,
                                                a.quizAnsweredCorrect,
                                                a.quizMakeAnswersUppercase,
                                                a.localRepresentativeState,
                                                a.noOfPeopleAnswered
                                            )}
                                        </ActionSuccess>
                                    )}
                                {(a.type === 'link' ||
                                    a.type === 'tweet' ||
                                    !actionCompleted(
                                        a,
                                        this.props.completedActionIdentifiers
                                    )) && (
                                    <ActionContent>
                                        {this.props.isMultiDonation && (
                                            <PartnerImage src={a.partner.logoUrl} />
                                        )}
                                        {!this.props.isMultiDonation && (
                                            <Title>
                                                {a.heading !== null
                                                    ? a.heading
                                                    : actionTitle(a.type)}
                                            </Title>
                                        )}
                                        <Description
                                            dangerouslySetInnerHTML={{
                                                __html: actionDescription(
                                                    this.props.isMultiDonation
                                                        ? a.partner.shortDescription
                                                        : a.name,
                                                    this.props.actions.length,
                                                    this.props.isMobileResolution
                                                )
                                            }}
                                            onClick={e =>
                                                !this.props.isMultiDonation
                                                    ? this.props.setOverlayPartnerVisible(
                                                          true,
                                                          e,
                                                          false
                                                      )
                                                    : e.preventDefault()
                                            }
                                        />
                                        <MultiActionsCardAction
                                            action={a}
                                            isMultiDonation={this.props.isMultiDonation}
                                            tweetContent={a.textOriginal || ''}
                                            key={a.identifier}
                                            label={
                                                a.label !== null
                                                    ? a.label
                                                    : this.props.isMultiDonation
                                                    ? 'SELECT'
                                                    : actionButton(a.type)
                                            }
                                            partnerName={a.partner ? a.partner.name : ''}
                                            localRepFound={this.props.localRepFound}
                                            localRepPostalCode={
                                                this.props.localRepPostalCode
                                            }
                                            localRepTwitterMention={
                                                this.props.localRepTwitterMention
                                            }
                                            publisherName={this.props.publisherName}
                                            articleUrl={this.props.articleUrl}
                                            showTwitterPopUp={
                                                !a.useLocalRepresentative ||
                                                (a.localRepresentativeState ===
                                                    LocalRepState.senators &&
                                                    !this.props.senatorsNotAvailable &&
                                                    this.props.localRepFound) ||
                                                (a.localRepresentativeState !==
                                                    LocalRepState.senators &&
                                                    this.props.localRepFound)
                                            }
                                            onClick={
                                                !a.useLocalRepresentative ||
                                                (a.localRepresentativeState ===
                                                    LocalRepState.senators &&
                                                    !this.props.senatorsNotAvailable &&
                                                    this.props.localRepFound) ||
                                                (a.localRepresentativeState !==
                                                    LocalRepState.senators &&
                                                    this.props.localRepFound)
                                                    ? () => {
                                                          if (isPortrait()) {
                                                              this.props.selectCard(
                                                                  a.position,
                                                                  a.identifier
                                                              );
                                                          }
                                                          if (a.type === 'tweet') {
                                                              this.props.onCompleteTweet(
                                                                  a.apiRequestData,
                                                                  this.props.actionCompletedTime(
                                                                      a.type
                                                                  )(),
                                                                  a.identifier,
                                                                  this.props
                                                                      .endUserLocation
                                                              );
                                                          } else if (a.type === 'link') {
                                                              window.open(
                                                                  a.linkUrl,
                                                                  '_blank'
                                                              );
                                                              this.props.onCompleteLink(
                                                                  a.apiRequestData,
                                                                  this.props.actionCompletedTime(
                                                                      a.type
                                                                  )(),
                                                                  a.identifier,
                                                                  this.props
                                                                      .endUserLocation
                                                              );
                                                          } else if (
                                                              a.type === 'volunteer'
                                                          ) {
                                                              this.props.postalCode
                                                                  ? this.props.onInitiateVolunteerAction(
                                                                        a.identifier
                                                                    ) ||
                                                                    this.props.fetchVolunteerOpportunities(
                                                                        this.props
                                                                            .postalCode,
                                                                        this.props
                                                                            .countryCode,
                                                                        a.id,
                                                                        a.identifier,
                                                                        true,
                                                                        this.props
                                                                            .postalCodeFormPopupIsVisible,
                                                                        false
                                                                    )
                                                                  : this.props.onShowLocationChangePopup(
                                                                        true,
                                                                        a.identifier
                                                                    );
                                                          } else {
                                                              return this.props.onGoToNextActionInsideCard(
                                                                  a.identifier,
                                                                  a.type,
                                                                  true
                                                              );
                                                          }
                                                      }
                                                    : () => {
                                                          if (isPortrait()) {
                                                              this.props.selectCard(
                                                                  a.position,
                                                                  a.identifier
                                                              );
                                                          }
                                                          this.props.goToFindLocalRep(
                                                              a.identifier,
                                                              'multiActionsCard'
                                                          );
                                                      }
                                            }
                                        />
                                    </ActionContent>
                                )}
                            </MultiActionsCardActionWrapper>
                        ))}
                    </Carousel>
                    <Footer>
                        <ShareDrawer
                            backgroundColor={'#fff'}
                            newsletterSignUpVisible={true}
                        />
                    </Footer>
                    <TransitionGroup>
                        {this.props.postalCodeFormPopupIsVisible && (
                            <CssTransition
                                key="alert"
                                in={this.props.postalCodeFormPopupIsVisible}
                            >
                                <LocationChangePopup
                                    onBack={() => {
                                        this.props.onShowLocationChangePopup(
                                            false,
                                            this.props.actionIdentifier
                                        );
                                    }}
                                />
                            </CssTransition>
                        )}
                    </TransitionGroup>
                </Body>
            </Container>
        );
    }
}

const useLocalRepresentative = state => {
    const actions = state.widget.actions.filter(function(a) {
        return (
            a.order === state.widget.activeAction.order &&
            a.localRepresentativeState !== LocalRepState.disabled
        );
    });
    return actions.length ? true : false;
};

MultiActionsCardDetails.propTypes = {
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    actions: PropTypes.array.isRequired,
    articleUrl: PropTypes.string,
    completedActionIdentifiers: PropTypes.array,
    countryCode: PropTypes.string,
    endUserLocation: PropTypes.object,
    fetchVolunteerOpportunities: PropTypes.func.isRequired,
    goToFindLocalRep: PropTypes.func.isRequired,
    isMobileResolution: PropTypes.bool.isRequired,
    isMultiDonation: PropTypes.bool,
    loadLocalRep: PropTypes.func.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    localRepPostalCode: PropTypes.string,
    localRepTwitterMention: PropTypes.string,
    mutiDonationHeader: PropTypes.string.isRequired,
    onCompleteLink: PropTypes.func.isRequired,
    onCompleteTweet: PropTypes.func.isRequired,
    onGoToNextActionInsideCard: PropTypes.func.isRequired,
    onInitiateVolunteerAction: PropTypes.func.isRequired,
    onShowLocationChangePopup: PropTypes.func.isRequired,
    postalCode: PropTypes.string,
    postalCodeFormPopupIsVisible: PropTypes.bool.isRequired,
    publisherName: PropTypes.string,
    selectCard: PropTypes.func.isRequired,
    senatorsNotAvailable: PropTypes.bool,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    useLocalRepresentative: PropTypes.bool
};

const allCompletedActions = state => {
    return (state.email.actionIdentifier || [])
        .map(id => ({ id, type: 'email' }))
        .concat((state.tweet.actionIdentifier || []).map(id => ({ id, type: 'tweet' })))
        .concat((state.link.actionIdentifier || []).map(id => ({ id, type: 'link' })))
        .concat((state.call.actionIdentifier || []).map(id => ({ id, type: 'call' })))
        .concat(
            (state.voteRegistration.actionIdentifier || []).map(id => ({
                id,
                type: 'voteregistration'
            }))
        )
        .concat(
            (state.electionReminder.actionIdentifier || []).map(id => ({
                id,
                type: 'electionreminder'
            }))
        )
        .concat(
            (state.checkRegistration.actionIdentifier || []).map(id => ({
                id,
                type: 'checkregistration'
            }))
        )
        .concat(
            (state.findPollingStation.actionIdentifier || []).map(id => ({
                id,
                type: 'findpollingstation'
            }))
        )
        .concat(
            (state.petition.actionIdentifier || []).map(id => ({
                id,
                type: 'petition'
            }))
        )
        .concat(
            (state.donation.actionIdentifier || []).map(id => ({
                id,
                type: 'donation'
            }))
        )
        .concat((state.poll.actionIdentifier || []).map(id => ({ id, type: 'poll' })))
        .concat(
            (state.sentimentPoll.actionIdentifier || []).map(id => ({
                id,
                type: 'sentimentpoll'
            }))
        )
        .concat((state.quiz.actionIdentifier || []).map(id => ({ id, type: 'quiz' })))
        .concat(
            (state.volunteer.actionIdentifier || []).map(id => ({
                id,
                type: 'volunteer'
            }))
        );
};

export default connect(
    state => {
        const reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.activeAction.localRepresentativeState,
                  state.localRep.localRepData.representative
              )
            : [];

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            actionInitiated: state.volunteer.actionInitiated,
            postalCodeFormPopupIsVisible: state.volunteer.postalCodeFormPopupIsVisible,
            isPetition: state.widget.activeAction.type === 'petition',
            isEmail: state.widget.activeAction.type === 'email',
            isTweet: state.widget.activeAction.type === 'tweet',
            isCall: state.widget.activeAction.type === 'call',
            regularRowSize: state.widget.regularRowSize,
            isMobileResolution: state.widget.isMobileResolution,
            postalCode: state.widget.endUserLocation
                ? state.widget.endUserLocation.postalCode
                : undefined,
            countryCode: state.widget.endUserLocation
                ? state.widget.endUserLocation.countryCode
                : 'US',
            localRepFound: state.localRep.localRepData.representative !== undefined,
            localRepPostalCode: state.localRep.localRepData.postalCode,
            localRepTwitterMention: joinEnglish(
                reps.map(rep => {
                    if (rep.twitterMention && rep.twitterMention.length > 0) {
                        return '@' + rep.twitterMention;
                    }
                    return rep.fullName;
                })
            ),
            useLocalRepresentative: useLocalRepresentative(state),
            completedActionIdentifiers: allCompletedActions(state),
            actionCompletedTime: actionType => getActionCompletedTime(state, actionType),
            senatorsNotAvailable:
                state.localRep.localRepData.representative !== undefined
                    ? state.localRep.localRepData.representative.length < 2
                    : false,
            actions: state.widget.actions
                .filter(function(a) {
                    return a.order === state.widget.activeAction.order;
                })
                .map(a => ({
                    text: a.text || a.description,
                    textOriginal: a.textOriginal || a.description,
                    label: a.customButtonText !== undefined ? a.customButtonText : null,
                    heading: a.customHeader !== undefined ? a.customHeader : null,
                    identifier: a.identifier,
                    id: a.id,
                    type: a.type,
                    position: state.widget.actions.indexOf(a),
                    name: (a.title || a.name)
                        .replace(
                            new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                            joinEnglish(
                                reps.map(rep => {
                                    if (
                                        rep.twitterMention &&
                                        rep.twitterMention.length > 0
                                    ) {
                                        return '@' + rep.twitterMention;
                                    }
                                    return rep.fullName;
                                })
                            )
                        )
                        .replace(
                            new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                            state.localRep.localRepData.representative != null
                                ? state.localRep.localRepData.postalCode
                                : '@PostalCode'
                        )
                        .replace(
                            new RegExp(Placeholders.ArticleUrl, 'g'),
                            state.widget.articleUrl
                        )
                        .replace(
                            new RegExp(Placeholders.LocalePlaceholder, 'g'),
                            (state.widget.endUserLocation || {}).regionName || 'your area'
                        ),
                    partner: a.partner,
                    useLocalRepresentative:
                        a.localRepresentativeState !== LocalRepState.disabled &&
                        a.localRepresentativeState !== undefined,
                    localRepresentativeState: a.localRepresentativeState,
                    thankYouText:
                        a.thankYouText || copyFor('multiaction', 'thankYouText'),
                    thankYouTitle: a.thankYouTitle,
                    recipientMask: a.recipientMask,
                    apiRequestData: getApiRequestData(a, state),
                    linkUrl:
                        a.url !== undefined
                            ? a.url.indexOf('http://') === 0 ||
                              a.url.indexOf('https://') === 0
                                ? a.url
                                : 'http://' + a.url
                            : '',
                    resultDistribution: state.sentimentPoll.resultDistribution,
                    pollResults:
                        a.possibleAnswers != null
                            ? a.possibleAnswers
                                  .filter(p => p.isOpen === false)
                                  .map(p => ({
                                      ...p,
                                      percentage:
                                          state.poll.answerHistory !== undefined
                                              ? state.poll.answerHistory.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ) !== undefined
                                                  ? state.poll.answerHistory
                                                        .find(
                                                            r =>
                                                                r.actionIdentifier ===
                                                                a.identifier
                                                        )
                                                        .results.find(
                                                            r => r.answerId === p.id
                                                        ) !== undefined
                                                      ? state.poll.answerHistory
                                                            .find(
                                                                r =>
                                                                    r.actionIdentifier ===
                                                                    a.identifier
                                                            )
                                                            .results.find(
                                                                r => r.answerId === p.id
                                                            ).percentage
                                                      : 0
                                                  : 0
                                              : 0,
                                      highestPercentage:
                                          state.poll.answerHistory !== undefined
                                              ? state.poll.answerHistory.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ) !== undefined
                                                  ? Math.max(
                                                        state.poll.answerHistory
                                                            .find(
                                                                r =>
                                                                    r.actionIdentifier ===
                                                                    a.identifier
                                                            )
                                                            .results.find(
                                                                r => r.isOpen !== false
                                                            ).percentage
                                                    )
                                                  : 0
                                              : 0,
                                      answerAnswered:
                                          state.poll.answerHistoryClicked !== undefined
                                              ? state.poll.answerHistoryClicked.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ) !== undefined
                                                  ? state.poll.answerHistoryClicked
                                                        .filter(
                                                            r =>
                                                                r.actionIdentifier ===
                                                                a.identifier
                                                        )
                                                        .slice(-1)[0].answerId === p.id
                                                  : state.poll.answerHistory !== undefined
                                                  ? state.poll.answerHistory.find(
                                                        r =>
                                                            r.actionIdentifier ===
                                                            a.identifier
                                                    ) !== undefined
                                                      ? state.poll.answerHistory.find(
                                                            r =>
                                                                r.actionIdentifier ===
                                                                a.identifier
                                                        ).answerId === p.id
                                                      : false
                                                  : false
                                              : state.poll.answerHistory !== undefined
                                              ? state.poll.answerHistory.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ) !== undefined
                                                  ? state.poll.answerHistory.find(
                                                        r =>
                                                            r.actionIdentifier ===
                                                            a.identifier
                                                    ).answerId === p.id
                                                  : false
                                              : false,
                                      noOfAnswers: a.possibleAnswers.filter(
                                          p => p.isOpen === false
                                      ).length,
                                      identifier: a.identifier
                                  }))
                            : [],
                    quizResults:
                        a.possibleAnswers != null
                            ? a.possibleAnswers.map(p => ({
                                  ...p,
                                  isCorrect: p.isCorrect,
                                  answerAnswered:
                                      state.quiz.answerHistory !== undefined
                                          ? state.quiz.answerHistory.find(
                                                r => r.actionIdentifier === a.identifier
                                            ) !== undefined
                                              ? state.quiz.answerHistory.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ).answerId === p.id
                                              : false
                                          : false,
                                  noOfAnswers: a.possibleAnswers.length
                              }))
                            : [],
                    quizAnsweredCorrect:
                        state.quiz.answerHistory !== undefined
                            ? state.quiz.answerHistory.find(
                                  r => r.actionIdentifier === a.identifier
                              ) !== undefined
                                ? state.quiz.answerHistory.find(
                                      r => r.actionIdentifier === a.identifier
                                  ).answerId ===
                                  state.quiz.answerHistory
                                      .find(r => r.actionIdentifier === a.identifier)
                                      .results.find(r => r.isCorrect).id
                                : false
                            : false,
                    quizMakeAnswersUppercase:
                        state.quiz.answerHistory !== undefined
                            ? state.quiz.answerHistory.find(
                                  r => r.actionIdentifier === a.identifier
                              ) !== undefined
                                ? state.quiz.answerHistory
                                      .find(r => r.actionIdentifier === a.identifier)
                                      .results.filter(function(a) {
                                          return a.text.length <= 8;
                                      })
                                : []
                            : [],
                    noOfPeopleAnswered: a.noOfAnswers
                        ? (a.noOfAnswers + 1).toLocaleString()
                        : ''
                })),
            mutiDonationHeader:
                state.widget.cards[state.widget.activeAction.order - 1].heading ||
                copyFor('multiaction', 'multiDonationHeader'),
            isMultiDonation:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multiDonation,
            publisherName:
                state.widget.twitterMention !== undefined
                    ? '@' + state.widget.twitterMention
                    : state.widget.publisherName,
            articleUrl: state.widget.articleUrl
        };
    },
    {
        onGoToNextActionInsideCard,
        goToFindLocalRep,
        loadLocalRep,
        setOverlayPartnerVisible,
        onCompleteTweet,
        onCompleteLink,
        selectCard,
        getApiRequestData,
        fetchVolunteerOpportunities,
        onInitiateVolunteerAction,
        onShowLocationChangePopup
    }
)(MultiActionsCardDetails);



// WEBPACK FOOTER //
// ./src/containers/MultiActionsCard/MultiActionsCardDetails.jsx